import { VStack, Text, Button } from '@chakra-ui/react';

import StoreItems from '~/components/StoreItems';

import * as fp from 'lodash/fp';

import useCartId from '~/hooks/useCartId';

import { useNavigate } from 'react-router-dom';

import { StoreOrderInCart } from '~/types/cart';

type StoreDisplayItemsListProps = {
  orders: Array<StoreOrderInCart>;
};

export default function StoreItemsDisplayList({ orders }: StoreDisplayItemsListProps) {
  const navigate = useNavigate();

  const { cartType } = useCartId();

  if (fp.eq(orders.length, 0)) {
    return (
      <VStack align="stretch" p={2} bgColor="gray.100">
        <Text my={5} fontWeight="bold" textAlign="center">
          目前無餐點，快來點餐
        </Text>
        <Button
          size="sm"
          isFullWidth
          bgColor="primaryLight"
          color="fontColor"
          onClick={() => navigate('/')}
          _hover={{ bgColor: 'primaryLight', color: 'fontColor' }}
          _active={{ bgColor: 'primaryLight', color: 'fontColor', opacity: 0.8 }}
        >
          去點餐
        </Button>
      </VStack>
    );
  }

  return (
    <VStack align="stretch" spacing={4}>
      {orders.map((order) => (
        <StoreItems key={order.storeId} order={order} cartType={cartType} />
      ))}
    </VStack>
  );
}
